'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var validityKeys = ['badInput', 'customError', 'patternMismatch', 'rangeOverflow', 'rangeUnderflow', 'stepMismatch', 'tooLong', 'tooShort', 'typeMismatch', 'valueMissing'];

exports.default = validityKeys;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/constants/validity-keys.js
// module id = 975
// module chunks = 0